<template>
  <div class="py-4 container-fluid" v-if="hasApprovalAccess">
    <div class="py-4 container-fluid">
      <ToastPrime position="bottom-left" />
      <div class="card">
        <div class="card-header py-3 position-relative border-bottom">
          <ButtonPrime
            v-tooltip.bottom="'Back to List'"
            icon="pi pi-arrow-left"
            text
            rounded
            severity="secondary"
            class="position-absolute start-0 ms-2"
            style="width: 2.5rem; height: 2.5rem; top: 50%; transform: translateY(-50%);"
            @click="goBack"
          />
          <h5 class="mb-0 fw-bold text-center mcr-title">Material Catalog Request (MCR)</h5>
        </div>

        <div class="card-body">
          <McrHeader />
          <!-- ref dipakai McrFooter buat menjangkau form yang sedang dirender di dalam McrItem -->
          <McrItem v-if="configReady" ref="mcrItem" class="mt-4" />
        </div>

        <div v-if="!isFromMaterialRequest" class="card-footer bg-white border-0 pb-5 pt-1">
          <McrFooter />
        </div>
      </div>
    </div>
  </div>
  <NoAccess v-else />
</template>

<script>
import { mapState } from "vuex";
import api from "@/helpers/api";
import requestListService from "@/services/materialCatalogingRequest/requestListService";
import McrHeader from "./McrHeader.vue";
import McrItem from "./New_McrItem.vue";
import McrFooter from "./New_McrFooter.vue";
import NoAccess from "@/components/NoAccess.vue";

export default {
  name: "McrForm",
  components: {
    McrHeader,
    McrItem,
    McrFooter,
    NoAccess
  },
  data() {
    return {
      hasApprovalAccess: true,
      // Route yang memakai new_mcr_process_config (selain itu, mis. draft, pakai drafting config).
      configReady: false,
    };
  },
  computed: {
    ...mapState({
      lastSavedAt: (state) => state.mcr.lastSavedAt,
      mcrDetail: (state) => state.mcr.mcrDetail,
    }),
    isFromMaterialRequest() {
      return this.$route.path.includes("material-request");
    },
  },
  watch: {
    lastSavedAt(val) {
      if (val) {
        const { id } = this.$route.params;
        this.$store.dispatch('mcr/fetchMcrHeader', { id });
      }
    },
  },
  async mounted() {
    const { id } = this.$route.params;
    // Mode route (meta.formMode) ikut menentukan form: mis. MCR send_back dari Material Request List (view) -> FORM02,
    // dari My Task (edit) -> FORM01. Lihat getters mcr/getFormCode & setting mcr_form_type `form_mode`.
    this.$store.commit('mcr/setFormMode', this.$route.meta?.formMode);
    if (id) {
      if (this.$route.path.includes('my-task')) {
        this.hasApprovalAccess = await this.checkApprovalAccess();
        if (!this.hasApprovalAccess) return;
      }
      // Header DITUNGGU dulu: getters mcr/getFormCode memilih form_code dari mcrHeader.type & status, dan
      // McrItem memilih komponen form dari form_code itu. Sebelumnya dispatch ini tidak di-await,
      // jadi kalau header belum keisi formCode tidak pernah ter-set → McrItem jatuh ke placeholder
      // "No Data" (tabel itemnya tidak muncul).
      try {
        await this.$store.dispatch('mcr/fetchMcrHeader', { id });
      } catch (error) {
        console.error('Failed to fetch MCR header:', error);
      }
    }

    // Get mcr form type (form_code per mcr_type) & form access (edit/view per role), saling independen
    try {
      await Promise.all([
        this.$store.dispatch('mcr/fetchMcrFormType'),
        this.$store.dispatch('mcr/fetchMcrFormAccess'),
      ]);
    } catch (error) {
      console.error('Failed to fetch form type/access:', error);
    }

    // Get form_code from vuex
    const getFormCode = this.$store.getters['mcr/getFormCode']
    if (getFormCode?.form_code) {
      try {
        await this.$store.dispatch('mcr/fetchFormConfig', getFormCode?.form_code);
      } catch (error) {
        console.error('Failed to fetch form config:', error);
      }
    }

    // McrItem baru dirender setelah form_code & access siap, supaya tidak sempat tampil
    // "No Data" / editable lalu berubah.
    this.configReady = true;
  },
  methods: {
    async checkApprovalAccess() {
      const mcrCode = this.$route.params.mcrCode || '';
      try {
        const result = await api(this, requestListService.checkCurrentApprovalStep(mcrCode), false);
        return !!result?.data;
      } catch (error) {
        return false;
      }
    },
    goBack() {
      this.$router.back();
    },
  }
};
</script>

<style scoped>
.mcr-title {
  color: #1e2d6e;
  font-size: 1rem;
  letter-spacing: 0.05em;
}
</style>
